// extracted by mini-css-extract-plugin
module.exports = {"viewMode":"DeliveryDetailsSection_viewMode__XIODg"};